<template>
	<div>
		<v-container>
			<v-row justify-space-around>
				<v-col xs12 sm8>
					<v-card flat height="100%">
						<div class="font-weight-medium">Profile</div>
						<v-divider></v-divider>
						<v-form>
							<v-container>
								<v-text-field
									label="Email"
									v-model="profile.email"
									readonly
									class="w-auto"
									variant="outlined"
								></v-text-field>
								<v-text-field
									label="First Name"
									required
									class="w-auto"
									variant="outlined"
									v-model="profile.firstName"
									:rules="[required('First Name')]"
								></v-text-field>
								<v-text-field
									label="Last Name"
									required
									class="w-auto"
									variant="outlined"
									v-model="profile.lastName"
									dense
								></v-text-field>
								<v-autocomplete
									v-model="profile.accountType"
									:items="accountTypeList"
									item-title="name"
									item-value="id"
									label="Account Type"
									placeholder="Account Type"
									class="w-auto"
									variant="outlined"
								></v-autocomplete>
								<v-switch
									color="grey"
									label="Dark Theme"
									dense
									v-model="profile.useDarkMode"
									@change="toggleDarkMode"
								></v-switch>
								<v-row class="justify-end">
									<v-spacer></v-spacer>
									<v-dialog v-model="dialog" max-width="500px">
										<template v-slot:activator="{}">
											<v-btn
												outlined
												class="blue--text font-weight-bold"
												@click="funEditItem(profile)"
												style="margin-right: -3%"
												>Change Password</v-btn
											>
										</template>
										<v-card>
											<v-card-title>
												<span class="text-h5">Change Password</span>
											</v-card-title>

											<v-card-text>
												<v-container>
													<input type="hidden" />
													<v-text-field
														class="w-auto"
														density="compact"
														variant="outlined"
														name="aNewPass"
														autocomplete="new-password"
														v-model="profile.password"
														placeholder="Password"
														prepend-icon="mdi-lock-outline"
														:type="showPass ? 'text' : 'password'"
														:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
														@input="validateForm"
														@click:append="showPass = !showPass"
														:rules="[rules.required, rules.min]"
													>
													</v-text-field>
													<v-text-field
														class="w-auto"
														density="compact"
														variant="outlined"
														name="aNewPassConfirm"
														autocomplete="new-password"
														v-model="profile.confirmPassword"
														placeholder="Confirm Password"
														prepend-icon="mdi-lock-outline"
														:type="showPassConfirm ? 'text' : 'password'"
														:append-icon="
															showPassConfirm ? 'mdi-eye' : 'mdi-eye-off'
														"
														@input="validateForm"
														@click:append="showPassConfirm = !showPassConfirm"
														:rules="[rules.required, rules.min]"
													>
													</v-text-field>
													<p v-if="errorMessage" style="color: red">
														{{ errorMessage }}
													</p>
												</v-container>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn
													v-if="passwordMatch"
													outlined
													class="blue--text font-weight-bold"
													@click="changePassword"
													:loading="loading"
													>Change Password</v-btn
												>
												<v-btn
													v-else
													style="color: gray"
													outlined
													class="blue--text font-weight-bold"
													:loading="loading"
													>Change Password</v-btn
												>
												<v-btn
													outlined
													class="blue--text font-weight-bold"
													@click="close"
													>Cancel</v-btn
												>
											</v-card-actions>
										</v-card>
									</v-dialog>
									<v-btn outlined
										   class="blue--text font-weight-bold submit-button"
										   @click="funUpdate"
										   :loading="loading">Submit</v-btn>
									
								</v-row>
							</v-container>
						</v-form>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import validations from "@/helpers/validations";
import { EDIT_USER_PASSWORD, EDIT_USER_PROFILE } from "@/store/_actiontypes";

export default {
	computed: {
		...mapState({
			user: (state) => state.account.user,
		}),
	},
	watch: {
		dialog(val) {
			val || this.close();
		},
	},
	methods: {
		...mapActions("account", [EDIT_USER_PASSWORD, EDIT_USER_PROFILE]),
		funUpdate() {
			this.loading = true;
			this.profile.accountType = this.profile.accountType;
			this.EDIT_USER_PROFILE(this.profile)
				.then(() => {
					localStorage.setItem("user", JSON.stringify(this.profile));
				})
				.finally(() => {
					this.loading = false;
				});
		},
		funEditItem(item) {
			this.profile = Object.assign({}, item);
			this.profile.accountType;
			this.dialog = true;
		},
		close() {
			this.dialog = false;
			this.profile.password = "";
			this.profile.confirmPassword = "";
			this.errorMessage = "";
		},
		async changePassword() {
			this.loading = true;
			const { email, password } = this.profile;
			if (password == undefined || password.length < 8) {
				alert("Pasword is less then 8 characters?");
				this.loading = false;
			} else {
				confirm("Are you sure you want to change password?") &&
					this.EDIT_USER_PASSWORD({ email, password })
						.then(() => {
							this.loading = false;
							this.close();
						})
						.finally(() => {
							this.loading = false;
						});
				this.loading = false;
			}
		},
		formatAcountType(type) {
			var ret = this.accountTypeList.find((h) => h.id == type);
			return ret.name;
		},
		validateForm() {
			const { password, confirmPassword } = this.profile;
			if (password === confirmPassword) {
				this.passwordMatch = true;
			} else if (password !== confirmPassword) {
				this.passwordMatch = false;
			}
			if (confirmPassword !== "") {
				if (password !== confirmPassword) {
					this.errorMessage = "Passwords do not match";
					return false;
				}
			}
			this.errorMessage = "";
			return true;
		},
		toggleDarkMode() {
			localStorage.setItem("darkMode", this.profile.useDarkMode ? "1" : "0");
		},
	},
	mounted() {
		const storedUser = localStorage.getItem("user");
		if (storedUser) {
			this.profile = JSON.parse(storedUser);
		} else {
			this.profile = {
				firstName: this.user.firstName,
				lastName: this.user.lastName,
				email: this.user.email,
				useDarkMode: this.user.useDarkMode,
				accountType: this.user.accountType,
				accountTypeName: this.formatAcountType(this.user.accountType),
				password: "",
				confirmPassword: "",
			};
		}
		const storedDarkMode = localStorage.getItem("darkMode");
		if (storedDarkMode !== null) {
			this.profile.useDarkMode = storedDarkMode === "1";
		} else {
			this.profile.useDarkMode = false;
		}
	},
	data: () => ({
		loading: false,
		dialog: false,
		showPass: false,
		showPassConfirm: false,
		errorMessage: "",
		passwordMatch: false,
		rules: {
			required: (key) => !!key || "Required.",
			min: (v) => (v != null && v.length >= 8) || "Min 8 characters",
			emailMatch: () => "The email and password you entered don't match",
		},
		profile: {},
		accountTypeList: [
			{ id: 0, name: "View" },
			{ id: 1, name: "User" },
			{ id: 2, name: "Admin" },
			{ id: 3, name: "SuperAdmin" },
		],
		...validations,
	}),
};
</script>

<style>
	.submit-button {
		margin-left: 16px;
	}
</style>
